module.exports = __webpack_public_path__ + "media/images/emblems/Wila-blazon-e63d98475db6828457adaef87213310d.svg";